import logo from '../../assets/logo/KPC23-Logotype-baseline-sans-fond-01.webp';

export const LogoFull = () => {
  return <img src={logo} height={56} alt="KPC" />;
};
